import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white border-t border-red-900/20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_c9569150-39ed-49a0-bcf7-6c91669fb705/artifacts/k5pmqpyw_IMG_8391%202.jpg" 
              alt="RELAX & RIDE Logo" 
              className="h-16 w-16 object-contain mb-4"
            />
            <h3 className="text-xl font-bold text-red-500 mb-2">RELAX & RIDE</h3>
            <p className="text-gray-400 text-sm">
              Your trusted transportation partner in The Bahamas. Professional, reliable, and comfortable taxi service available 24/7.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-red-500">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  Rates
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-red-500 transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-red-500">Our Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Airport Transfers</li>
              <li>Island Tours</li>
              <li>Corporate Transportation</li>
              <li>Special Events</li>
              <li>24/7 Service</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-red-500">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Phone className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <a href="tel:+12425258675" className="hover:text-red-500 transition-colors">
                  +1242-525-8675
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Mail className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <a href="mailto:rasrio777@hotmail.com" className="hover:text-red-500 transition-colors break-all">
                  rasrio777@hotmail.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
                <span>Nassau, The Bahamas</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 bg-red-900/20 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-red-900/20 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-red-900/20 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-red-900/20 mt-8 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} RELAX & RIDE. All rights reserved.</p>
          <div className="mt-2">
            <Link to="/driver-login" className="text-gray-500 hover:text-red-500 text-xs transition-colors">
              Driver Portal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
